export enum RouteName {
  List = 'wallets-list',
}
